export default "__VITE_ASSET__DJ9TFHCK__"